import { render, staticRenderFns } from "./EffectiveDocList.vue?vue&type=template&id=08f81324&scoped=true&"
import script from "./EffectiveDocList.vue?vue&type=script&lang=js&"
export * from "./EffectiveDocList.vue?vue&type=script&lang=js&"
import style0 from "./EffectiveDocList.vue?vue&type=style&index=0&id=08f81324&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f81324",
  null
  
)

export default component.exports